export * from 'server/models/BerthAmenityType';


// WEBPACK FOOTER //
// ./data/models/BerthAmenityType.ts